import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { 
  Calendar, 
  Clock, 
  Package, 
  TrendingUp,
  ArrowLeft
} from 'lucide-react';

const AssortmentPlanner = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mb-6">
            <Package className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Assortment Planner
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Advanced AI-powered assortment planning tool to optimize your product mix for maximum retailer appeal and profitability.
          </p>
        </div>

        {/* Coming Soon Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <div className="text-center">
            {/* Coming Soon Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-orange-400 to-pink-500 text-white rounded-full text-sm font-medium mb-6">
              <Clock className="h-4 w-4 mr-2" />
              Coming Soon
            </div>

            {/* Main Message */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              We're Building Something Amazing!
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Our Assortment Planner is currently under development. This powerful tool will help you optimize your product mix using advanced analytics and AI-driven insights.
            </p>

            {/* Features Preview */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-6">
                <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <TrendingUp className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Smart Analytics</h3>
                <p className="text-gray-600 text-sm">
                  AI-powered insights to optimize your product assortment for maximum retailer appeal
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6">
                <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <Package className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Product Optimization</h3>
                <p className="text-gray-600 text-sm">
                  Intelligent recommendations for SKU mix, pricing, and category coverage
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-6">
                <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <Calendar className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Strategic Planning</h3>
                <p className="text-gray-600 text-sm">
                  Seasonal planning and trend analysis to stay ahead of market demands
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* Alternative Actions */}
        <div className="text-center">
          <p className="text-gray-600 mb-4">
            In the meantime, explore our other powerful tools:
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </button>
            <button
              onClick={() => window.location.href = '/discovery'}
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all font-medium"
            >
              <TrendingUp className="h-4 w-4 mr-2" />
              Explore Discovery
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-12 text-gray-500">
          <p>Thank you for your patience as we build this exciting feature!</p>
        </div>
      </div>
    </div>
  );
};

export default AssortmentPlanner;